import { render, staticRenderFns } from "./Whatson.vue?vue&type=template&id=643cf851&"
import script from "./Whatson.vue?vue&type=script&lang=js&"
export * from "./Whatson.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports